module.exports = __webpack_public_path__ + "media/video-paperclicks-home.1eba6b88.mp4";